import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import {FcEnteringHeavenAlive, FcIphone} from 'react-icons/fc'
import {BiDumbbell} from 'react-icons/bi'
import {IoMdWatch} from 'react-icons/io'
import {FaPrescriptionBottle} from 'react-icons/fa'
import CommunityPosts from './community_posts'
import LiveWorkouts from './live_workouts'
import Equipment from './equipment'
import SportswearAndAccessories from './sportswear_and_accessories'
import NutritionAndNutritionalPlans from './nutrition_and_nutritional_plans'

  class Explore extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        current_render: 'community_posts',
        community_posts: '#1faced',
        live_workouts: '',
        equipment: '',
        sportswear_and_accessories: '',
        nutrition_and_nutritional_plans: ''
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.ChangeRender = (new_render) => {
        var previous_selection = this.state.current_render
        this.state[previous_selection] = ''
        this.setState({current_render: new_render})
        this.state[new_render] = '#1faced'
      }

      this.Render = () => {
        var render = this.state.current_render

        if(render == 'community_posts'){
          return<CommunityPosts/>
        }else if(render == 'live_workouts'){
          return<LiveWorkouts/>
        }else if(render == 'equipment'){
          return<Equipment/>
        }else if(render == 'sportswear_and_accessories'){
          return<SportswearAndAccessories/>
        }else if(render == 'nutrition_and_nutritional_plans'){
          return<NutritionAndNutritionalPlans/>
        }
      }
    }

    componentDidMount() {

    }




    render() {
      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>EXPLORE - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Container>
              <br/><br/><br/>
              <Row style={{}}>
                <Col>
                  <Button onClick={() => this.ChangeRender('community_posts')} style={{border: 'none', backgroundColor: 'inherit', color: 'inherit'}}>
                    <FcIphone size='60px' style={{color: this.state.community_posts}}/>
                    <h3 style={{fontSize: '14px', marginTop: '15px'}}>
                      Community Posts
                    </h3>
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => this.ChangeRender('live_workouts')} style={{border: 'none', backgroundColor: 'inherit', color: 'inherit'}}>
                    <FcEnteringHeavenAlive size='60px' style={{color: this.state.live_workouts}}/>
                    <h3 style={{fontSize: '14px', marginTop: '15px'}}>
                      Live workouts
                    </h3>
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => this.ChangeRender('equipment')} style={{border: 'none', backgroundColor: 'inherit', color: 'inherit'}}>
                    <BiDumbbell size='60px' style={{color: this.state.equipment}}/>
                    <h3 style={{fontSize: '14px', marginTop: '15px'}}>
                      Equipment
                    </h3>
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => this.ChangeRender('sportswear_and_accessories')} style={{border: 'none', backgroundColor: 'inherit', color: 'inherit'}}>
                    <IoMdWatch size='60px' style={{color: this.state.sportswear_and_accessories}}/>
                    <h3 style={{fontSize: '14px', marginTop: '15px'}}>
                      Sportswear and Accessories
                    </h3>
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => this.ChangeRender('nutrition_and_nutritional_plans')} style={{border: 'none', backgroundColor: 'inherit', color: 'inherit'}}>
                    <FaPrescriptionBottle size='60px' style={{color: this.state.nutrition_and_nutritional_plans}}/>
                    <h3 style={{fontSize: '14px', marginTop: '15px'}}>
                      Nutrition and Nutritional Plans
                    </h3>
                  </Button>
                </Col>
              </Row>
              <br/><br/><br/>
              <this.Render/>
            </Container>
            <br/><br/><br/>
        </div>
      );
    }

  };
  
  export default withCookies(Explore);